import { Link } from "react-router-dom";
import { loginPath } from "../../components/routes/path";

const AReply = () => {
  return (
    <div className="bg-white p-10 ">
      <p className="text-2xl">Leave a Reply</p>
      <p className="text-sm ">
        Logged in as Yusuf. Edit your profile.
        <Link to={loginPath}> Log out? </Link> Required fields are marked *
      </p>
      <form className="mt-10">
        <label className="block text-sm text-gray-700" htmlFor="reply">
          Comment *
        </label>
        <textarea
          id="reply"
          name="reply"
          rows="10"
          required
          className="block w-full border outline-none bg-[#F7F7F7] border-[#66B2FF] p-2 rounded-md focus:border-[#3b76db]"
        />
        <div className="flex justify-start mt-4">
          <button className="px-4 py-3 text-sm text-white bg-[#3b76db] rounded hover:bg-primary-600">
            Post Comment
          </button>
        </div>
      </form>
    </div>
  );
};

export default AReply;
